import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';
import { PromoItem } from '../PromoItem/PromoItem.es.js';

var PromoBlockStatus;
(function (PromoBlockStatus) {
    PromoBlockStatus["SELECTED"] = "selected";
    PromoBlockStatus["ACTIVE"] = "active";
    PromoBlockStatus["INACTIVE"] = "inactive";
})(PromoBlockStatus || (PromoBlockStatus = {}));
const Container = styled.div(({ hasBorderRadius, hasBorder, theme: { colors }, blockBackground, }) => `
    width: 100%;
    padding: 1rem 0 1rem 1rem;
    background-color: ${blockBackground ? blockBackground : 'white'};
    display: flex;
    align-items: center;
    border-bottom: ${hasBorder ? `1px solid ${colors.border}` : 'none'};
    border-radius: ${hasBorderRadius ? `8px` : '0'};
    margin-bottom: 12px;
  `);
const Left = styled.div(({ theme: { colors }, showRight }) => `
    border-right: ${showRight ? `1px dashed ${colors.border}` : `unset`};
    padding-right: 1rem;
    flex: 1;
  `);
const Description = styled.p(({ theme: { colors } }) => `
    margin: 0;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    color: ${colors.gray130};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 0.75rem;
  `);
const Button = styled.span(({ isActive, theme: { colors } }) => `
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${isActive ? colors.link500 : colors.gray130};
    width: 6rem;
    text-align: center;
    padding: 0.5rem;

    &:hover {
      cursor: pointer;
    }
`);
const StyledPromoItem = styled(PromoItem) `
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
const PromoBlock = ({ benefits, description, status, hasBorder, hasBorderRadius = false, blockBackground, customBtn, onClick, showRight = true, }) => {
    const statusMap = {
        [PromoBlockStatus.SELECTED]: t('Bỏ chọn'),
        [PromoBlockStatus.ACTIVE]: t('Áp dụng'),
        [PromoBlockStatus.INACTIVE]: t('Mua thêm'),
    };
    return (React.createElement(Container, { hasBorder: hasBorder, hasBorderRadius: hasBorderRadius, blockBackground: blockBackground },
        React.createElement(Left, { showRight: showRight },
            description && React.createElement(Description, null, description),
            benefits.map(({ type, text, imgSrc }, index) => (React.createElement(StyledPromoItem, { type: type, text: text, imgSrc: imgSrc, key: index })))),
        showRight &&
            (customBtn || (React.createElement(Button, { isActive: status !== PromoBlockStatus.INACTIVE, onClick: onClick }, statusMap[status] || '')))));
};

export { PromoBlock, PromoBlockStatus };
